export enum TrackingEventEnum {
	Conversion = 'conversion',
	ButtonClick = 'button_click',
	ClickToCall = 'click_to_call',
	ConsentUpdate = 'consent_update',
	FormAction = 'form_action',
	ViewMembership = 'view_membership'
}
